module.exports = __webpack_public_path__ + "static/media/zatrazi_donaciju_vector.05994123.svg";